import React from "react";

const videoStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  minWidth: "100%",
  minHeight: "100%",
  width: "auto",
  height: "auto",
  zIndex: "-100",
  transform: "translateX(-50%) translateY(-50%)",
  backgroundColor: "rgb(0, 0, 0)",
};

function isVideoFile(filename: string) {
  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov"];
  const extension = filename.slice(filename.lastIndexOf(".")).toLowerCase();
  return videoExtensions.includes(extension);
}

export default function AnimatedBackground({ body }) {
  if (body) {
    const bodyStyle = window.getComputedStyle(body);
    const urlRegex = /url\(['"]?([^'"]*)['"]?\)/;
    const matches = bodyStyle.background.match(urlRegex);
    const url = matches?.[1];

    if (url) {
      const isVideo = isVideoFile(url);

      if (isVideo) {
        return (
          <video style={videoStyle} autoPlay playsInline muted poster="" loop controls={false} preload="auto">
            <source src={url} type="video/mp4" />
            <source src={url} type="video/webm" />
          </video>
        );
      }
    }
  }

  return null;
}
